/**
 * Scherm dat de applicatie STOPT wanneer deze client aantoonbaar een oudere
 * build draait dan de server bedient en herladen niet heeft geholpen.
 *
 * WAAROM BLOKKEREN EN NIET EEN BALK. De eerste opzet toonde een wegklikbare
 * melding. Dat is precies wat er misging bij het voorval van 01-09-2026: een
 * verouderde client bleef gewoon doorwerken, en de gebruiker had geen enkele
 * reden om aan te nemen dat er iets mis was. Een build die aantoonbaar niet meer
 * klopt, mag niet blijven schrijven.
 *
 * Automatisch herladen gebeurt hoogstens `MAX_HERLADINGEN` keer; helpt dat niet,
 * dan is dit scherm het eindstation en beslist de gebruiker. Zo kan er geen
 * herlaadlus ontstaan.
 */
const SCHERM_ID = "collectr-verouderde-build";

export function toonVerouderdeBuild(
  doc: Document = document,
  detail?: { draaiend: string; actueel: string },
): void {
  if (doc.getElementById(SCHERM_ID)) return;

  const laag = doc.createElement("div");
  laag.id = SCHERM_ID;
  laag.setAttribute("role", "alertdialog");
  laag.setAttribute("aria-modal", "true");
  laag.setAttribute(
    "style",
    "position:fixed;inset:0;z-index:2147483600;display:flex;align-items:center;" +
      "justify-content:center;padding:1.5rem;background:rgba(15,23,42,.72);" +
      "font:14px/1.55 system-ui,-apple-system,Segoe UI,sans-serif",
  );

  const kaart = doc.createElement("div");
  kaart.setAttribute(
    "style",
    "max-width:30rem;padding:1.5rem;border-radius:.75rem;background:#fff;color:#0f172a;" +
      "box-shadow:0 20px 50px rgba(0,0,0,.35)",
  );

  const kop = doc.createElement("h1");
  kop.textContent = "Deze pagina draait een verouderde versie";
  kop.setAttribute("style", "margin:0 0 .5rem;font-size:1.05rem;font-weight:600");
  kaart.appendChild(kop);

  const p = doc.createElement("p");
  p.textContent =
    "Er is inmiddels een nieuwere versie van Collectr uitgerold. Om te voorkomen dat " +
    "je met verouderde code werkt, is deze pagina gestopt. Herlaad om verder te gaan.";
  p.setAttribute("style", "margin:0 0 1rem");
  kaart.appendChild(p);

  if (detail) {
    const regels = doc.createElement("p");
    regels.textContent = `Deze pagina: ${detail.draaiend} · Server: ${detail.actueel}`;
    regels.setAttribute(
      "style",
      "margin:0 0 1rem;font-family:ui-monospace,monospace;font-size:12px;color:#475569",
    );
    kaart.appendChild(regels);
  }

  const knop = doc.createElement("button");
  knop.type = "button";
  knop.textContent = "Nu herladen";
  knop.setAttribute(
    "style",
    "border:0;border-radius:.4rem;padding:.55rem 1rem;background:#1d4ed8;color:#fff;" +
      "font:inherit;font-weight:500;cursor:pointer",
  );
  knop.addEventListener("click", () => {
    doc.defaultView?.location.reload();
  });
  kaart.appendChild(knop);

  laag.appendChild(kaart);
  doc.body.appendChild(laag);
}
